import React, { Component } from 'react';
import { Scoped } from 'kremling';
import styles from './integrations.styles.scss';
import { UserStateContext } from 'context/user-state-context';
import { Button } from '../../components/button/button.component';
import { createCredentials as createCredentialsAPI, updateCredential as updateCredentialsAPI, deleteCredential as deleteCredentialsAPI } from './integrations.resource';
import { toasterService } from '../../components/toaster/toaster-service';
import { ModalDialog } from '../../components/modal/modal-dialog.component';
const INTEGRATION_KEY = 'agemni';
export class IntegrationAgemni extends Component {
  static contextType = UserStateContext;
  static propTypes = {};
  state = {
    deleteCredential: {},
    updateCredential: {},
    isCredentialModalOpen: false,
    username: null,
    password: null,
    dn: null
  };
  addCredential = (username, password, dn) => {
    return createCredentialsAPI({
      identifier: username,
      secret1: password,
      secret2: dn,
      company: this.context.asCompany.id,
      integration: INTEGRATION_KEY
    }).then(() => toasterService.success('Successfully added franchise.')).then(() => this.props.reload()).catch(err => {
      if (err.response.data.non_field_errors) {
        toasterService.error(err.response.data.non_field_errors[0]);
      } else {
        toasterService.error('Unknown error trying to add credentials. Please try again.');
      }
    });
  };
  updateCredential = (id, username, password, dn) => {
    return updateCredentialsAPI(id, {
      identifier: username,
      secret1: password,
      secret2: dn
    }).then(() => toasterService.success('Successfully updated credentials.')).then(() => this.props.reload()).catch(err => {
      if (err.response.data.site_id) {
        toasterService.error(err.response.data.site_id[0]);
      } else {
        toasterService.error('Unknown error trying to update franchise. Please try again.');
      }
    });
  };
  removeCredentials = credentialsId => {
    return deleteCredentialsAPI(credentialsId).then(() => toasterService.success('Successfully deleted credentials')).then(() => this.props.reload()).catch(() => toasterService.error('Unknown error to trying delete credentials. Please try again.'));
  };
  render() {
    const {
      credentials
    } = this.props;
    const {
      isCredentialModalOpen,
      username,
      password,
      dn,
      deleteCredential,
      updateCredential
    } = this.state;
    return <Scoped css={styles}>
        <div className="integration mb-5">
          <div className="integration__header">
            <div>Agemni</div>
            {this.context.hasPermission('integration.add_credential') && <Button className="btn" actionType="primary" tag="a" onClick={() => this.setState({
            isCredentialModalOpen: true
          })}>
                Add Credentials
              </Button>}
          </div>
          <div className="integration__body">
            {credentials.map(credential => <div className="integration-item" key={credential.id}>
                <div className="integration-item__inner">
                  <div className="integration-title">
                    {credential.identifier}
                  </div>
                  <div className="integration-actions">
                    {this.context.hasPermission('integration.change_credential') && <Button actionType="flat" icon="fa-regular-edit" onClick={e => {
                  e.stopPropagation();
                  this.setState({
                    updateCredential: credential
                  });
                }} />}
                    {this.context.hasPermission('integration.delete_credential') && <Button actionType="flat" icon="fa-regular-trash" onClick={e => {
                  e.stopPropagation();
                  this.setState({
                    deleteCredential: credential
                  });
                }} />}
                  </div>
                </div>
              </div>)}
          </div>

          <ModalDialog open={!!deleteCredential.id} title="Remove Credential" submitText="Remove" onSubmit={() => this.removeCredentials(deleteCredential.id)} onClose={() => this.setState({
          deleteCredential: {}
        })} allowBackdropClick>
            <p>
              <strong>{deleteCredential.username}</strong>
            </p>
            <p>Are you sure you want to remove this credential?</p>
          </ModalDialog>

          <ModalDialog open={isCredentialModalOpen} title="Add Credential" onSubmit={() => this.addCredential(username, password, dn)} onClose={() => this.setState({
          isCredentialModalOpen: false
        })} allowBackdropClick>
            <p>
              Please enter your Agemni information below to link to your
              account.
            </p>
            <p>
              <label>Username</label>
              <input required className="form-control" name="username" onChange={e => this.setState({
              username: e.target.value
            })} />
            </p>
            <p>
              <label>Password</label>
              <input required className="form-control" name="password" type="password" onChange={e => this.setState({
              password: e.target.value
            })} />
            </p>
            <p>
              <label>DN</label>
              <input required className="form-control" name="franchise_ref" onChange={e => this.setState({
              dn: e.target.value
            })} />
            </p>
          </ModalDialog>

          <ModalDialog open={!!updateCredential.id} title="Update Credential" submitText="Update" onSubmit={() => this.updateCredential(updateCredential.id, username, password, dn)} onClose={() => this.setState({
          updateCredential: {}
        })} allowBackdropClick>
            <p>Please update your Agemni information below.</p>
            <p>
              <label>Username</label>
              <input required className="form-control" name="username" defaultValue={updateCredential.identifier || ''} onChange={e => this.setState({
              username: e.target.value
            })} />
            </p>
            <p>
              <label>Password</label>
              <input required className="form-control" name="password" type="password" onChange={e => this.setState({
              password: e.target.value
            })} />
            </p>
            <p>
              <label>DN</label>
              <input required className="form-control" name="dn" onChange={e => this.setState({
              dn: e.target.value
            })} />
            </p>
          </ModalDialog>
        </div>
      </Scoped>;
  }
}